import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiDataModelResponseRendererComponent } from './data-model/ai-data-model-response-renderer.component';
import { AiEntityComponentResponseRendererComponent } from './entity-component/ai-entity-component-response-renderer.component';
import { AIResponseStructure, AIGenerationType } from '../../utils/ai-response-types.interface';
import { ProjectChannelMessage } from '@rappider/rappider-sdk';

@Component({
  selector: 'rappider-ai-response-renderer',
  standalone: true,
  imports: [
    CommonModule,
    AiDataModelResponseRendererComponent,
    AiEntityComponentResponseRendererComponent
  ],
  templateUrl: './ai-response-renderer.component.html',
  styleUrls: ['./ai-response-renderer.component.scss']
})
export class AIResponseRendererComponent {
  @Input() message: unknown;
  @Input() responseType: AIGenerationType | undefined;
  @Input() allMessages?: ProjectChannelMessage[];

  @Output() responseAction = new EventEmitter<{ type: string; data: unknown }>();
  @Output() splitterToggleRequested = new EventEmitter<boolean>();
  @Output() revertRequested = new EventEmitter<{ messageId: string; draftId: string; stepId: string }>();

  readonly AIGenerationType = AIGenerationType;


  /**
   * Get response data from message
   */
  getResponseData(): AIResponseStructure | AIResponseStructure[] | null {
    const messageObj = this.message as Record<string, unknown>;
    return messageObj?.responseData as AIResponseStructure | AIResponseStructure[] | null;
  }

  /**
   * Handle response actions from child renderers
   */
  onResponseAction(event: unknown): void {
    this.responseAction.emit(event as { type: string; data: unknown });
  }

  /**
   * Handle splitter toggle requests from child renderers
   */
  onSplitterToggleRequested(shouldOpen: boolean): void {
    this.splitterToggleRequested.emit(shouldOpen);
  }

  /**
   * Handle revert requests from child renderers
   */
  onRevertRequested(event: { messageId: string; draftId: string; stepId: string }): void {
    this.revertRequested.emit(event);
  }

  /**
   * Get project model ID from message or context
   */
  getProjectModelId(): string | undefined {
    const messageObj = this.message as Record<string, unknown>;
    return messageObj?.projectModelId as string || undefined;
  }

  /**
   * Get message ID from message
   */
  getMessageId(): string | undefined {
    const messageObj = this.message as Record<string, unknown>;
    return messageObj?.messageId as string || messageObj?.id as string || undefined;
  }

  /**
   * Get component definition ID from message
   */
  getComponentDefinitionId(): string | undefined {
    const messageObj = this.message as Record<string, unknown>;
    return messageObj?.componentDefinitionId as string || undefined;
  }
}
